export default [
  {
    path: 'recruitment',
    component: () => import('@/admin/pages/recruitment/Index'),
    name: 'admin.recruitment.index',
    meta: { auth: true }
  },
  {
    path: 'recruitment/job-postings',
    component: () => import('@/admin/pages/recruitment/job-postings/Index'),
    name: 'admin.recruitment.job-postings',
    meta: { auth: true }
  },
];
